module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#fb",
      toString: function () {
        return this.url;
      }
    }